module.exports = __webpack_public_path__ + "img/shiftable.aae10e92.svg";